module.exports = __webpack_public_path__ + "img/gps.5492ba30.png";